import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AcceptInvitation } from '@/pages/auth/accept-invitation/AcceptInvitation';

const searchSchema = z.object({
	token: z.string().optional(),
	// The invite link carries the email base64-encoded; trimming/lower-casing it
	// corrupts the base64 so atob() later decodes to garbage (VAD-677). Keep it verbatim.
	email: z.string().optional(),
	companyID: z.string().optional(),
});

export const Route = createFileRoute('/accept-invitation-token')({
	validateSearch: searchSchema,
	component: AcceptInvitation,
});
